import { createAction, props } from '@ngrx/store';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { EdicaoOutputDto } from 'src/app/domain/DTOs/output/jornal/edicao-output.dto';

const actionName = "[ ObterUltimaEdicao ] Obter Ultima Edicao";

export const obterUltimaEdicao = createAction(
  actionName
);

export const obterUltimaEdicaoSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> }>()
);

export const obterUltimaEdicaoFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> }>()
);

export const obterUltimaEdicaoFinish = createAction(
  `${actionName} - Concluir`
);
